import e, { useState as t, useRef as r, useEffect as n, useImperativeHandle as o } from "react";
import { componentName as l } from "../../../utils/bem/index.js";
import { SidebarItem as i } from "./components/SidebarItem.js";
import { SidebarDrawer as a } from "./components/Drawer.js";
import { SidebarHeading as s } from "./components/SidebarHeading.js";
import { NavigationResizeButton as m } from "./components/NavigationResizeButton.js";
import { getRelativeUrl as u } from "../../../utils/browser/index.js";
import { t as c } from "../../../i18/index.js";
import { tip as p } from "../../forms/Tooltip/Tooltip.js";
import "../../../../node_modules/classnames/index.js";
import { Submenu as f } from "./components/Submenu.js";
function d(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function y(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var r,
      n,
      o = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != o) {
      var l = [],
        i = !0,
        a = !1;
      try {
        for (o = o.call(e); !(i = (r = o.next()).done) && (l.push(r.value), !t || l.length !== t); i = !0);
      } catch (e) {
        a = !0, n = e;
      } finally {
        try {
          i || null == o.return || o.return();
        } finally {
          if (a) throw n;
        }
      }
      return l;
    }
  }(e, t) || function (e, t) {
    if (e) {
      if ("string" == typeof e) return d(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if ("Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r) return Array.from(r);
      if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return d(e, t);
    }
  }(e, t) || function () {
    throw TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
var v = e.forwardRef(function (d, v) {
  var b = d.className,
    h = d.isCollapsible,
    g = d.children,
    C = d.items,
    E = d.itemsDrawer,
    j = d.hasDrawer,
    x = d.itemTemplate,
    k = d.headingTemplate,
    w = d.onItemClick,
    T = d.isActiveItem,
    S = d.onExpand,
    A = d.onCollapse,
    _ = d.onResizeButtonToggle,
    I = d.templateClasses,
    N = function N() {
      !0 !== q && (z(!0), null == A || A());
    },
    D = function D() {
      !1 !== q && (z(!1), null == S || S());
    },
    O = function O(e) {
      if (T) return T(e);
      var t = u(e.path);
      return -1 !== window.location.pathname.indexOf(t);
    },
    R = y(t(!1), 2),
    q = R[0],
    z = R[1],
    B = y(t([]), 2),
    F = B[0],
    H = B[1],
    L = r(null),
    M = r(null),
    P = function P() {
      var e,
        t,
        r = null === (e = M.current) || void 0 === e ? void 0 : e.querySelectorAll("." + I.tooltipTextClass),
        n = null === (t = M.current) || void 0 === t ? void 0 : t.querySelectorAll("." + I.tooltipTargetClass),
        o = [];
      (null == r ? void 0 : r.length) && (r.forEach(function (e, t) {
        o.push(p({
          className: "kaseya-ui-sidebar__tooltip",
          target: n[t],
          content: c(e.innerText),
          options: {
            position: "right"
          }
        }));
      }), H(o));
    },
    U = function U(e, t) {
      return function (r) {
        return w(e, t, r);
      };
    };
  n(function () {
    return P(), function () {
      F.forEach(function (e) {
        e.destroy();
      });
    };
  }, [C]), o(v, function () {
    return {
      collapse: N,
      expand: D
    };
  });
  var $ = e.createElement("div", null, null == E ? void 0 : E.map(function (t, r) {
    if ("link" === t.type) return e.createElement(i, {
      key: r,
      item: t,
      template: x,
      templateClasses: I,
      onClick: U(t, r)
    });
  }));
  return e.createElement(e.Fragment, null, e.createElement("aside", {
    className: l("sidebar", b, {
      collapsed: q
    }),
    ref: L
  }, e.createElement("div", {
    className: "sidebar__container",
    ref: M
  }, g || null, null == C ? void 0 : C.map(function (t, r) {
    return "folder" === t.type ? e.createElement(s, {
      template: k,
      key: r,
      item: t
    }) : "link" === t.type ? e.createElement(i, {
      key: r,
      item: t,
      template: x,
      templateClasses: I,
      active: O(t),
      onClick: U(t, r)
    }) : "submenu" === t.type ? e.createElement(f, {
      key: r,
      item: t,
      template: x,
      templateClasses: I,
      onItemClick: U,
      isLinkActive: O,
      onExpand: D,
      isCollapsed: q
    }) : void 0;
  }), e.createElement("div", {
    className: "sidebar-drawer"
  }, j && e.createElement(a, {
    itemsDrawer: $,
    title: c("more")
  }))), e.createElement("div", {
    className: "sidebar__empty-vertical"
  }, h && e.createElement(m, {
    isCollapsed: q,
    onToggle: function onToggle() {
      q ? null == S || S() : null == A || A(), z(!q), null == _ || _();
    }
  }))));
});
v.defaultProps = {
  isCollapsible: !1,
  hasDrawer: !1,
  templateClasses: {
    tooltipTargetClass: "sidebar-item-tooltip-mount",
    tooltipTextClass: "sidebar-item__title"
  }
};
export { v as Sidebar };